<template>
  <footer class="bg-white py-6">
    <div class="mx-auto w-full max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col sm:flex-row sm:justify-between items-center text-center sm:text-left">
        <div class="mb-6 sm:mb-0 flex items-center">
          <a href="#" class="flex items-center">
            <img src="/images/logo.svg" class="h-12 mr-2" alt="logo" />
          </a>
        </div>
        <div class="flex space-x-4">
          <a href="https://www.facebook.com/profile.php?id=61553140545332" class="hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1877F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3.2c-1.7 0-3 .5-4 1.5s-1.4 2.3-1.4 3.8v3H6v4h3.4v9h4v-9H17l1-4h-4v-2c0-.6.2-1.1.6-1.4s.9-.6 1.4-.6H18V2z"/>
            </svg>
          </a>
          <a href="https://www.linkedin.com" class="hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0A66C2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="3" ry="3"/>
              <path d="M8 11v6M8 8v0M16 17v-3.5a2 2 0 0 0-4 0V17"/>
            </svg>
          </a>
        </div>
      </div>

      <div class="mt-4 text-center sm:text-left">
        <ul class="flex flex-wrap justify-center sm:justify-start space-x-4 text-sm text-gray-500">
          <li><button @click="scrollToTextComponent" class="hover:underline">O nas</button></li>
          <li><router-link to="/galeria" class="hover:underline">Nasze realizacje</router-link></li>
          <li><a href="#" @click.prevent="showPrivacyPolicy = true" class="hover:underline">Polityka prywatności</a></li>
        </ul>
      </div>

      <hr class="my-4 border-gray-200" />
      <div class="text-center text-sm text-gray-500">
        <span>© 2023 ProjectSpot. Wszelkie prawa zastrzeżone.</span>
        <br class="sm:hidden" />
        <span> Administratorem danych osobowych jest ProjectSpot. Dane są przetwarzane zgodnie z polityką prywatności.</span>
      </div>
    </div>

    <!-- Modal Polityki Prywatności -->
    <div v-if="showPrivacyPolicy" class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full text-left relative mt-8 mb-8">
        <h2 class="text-xl font-bold text-gray-900 mb-4">Polityka Prywatności</h2>
        <div class="text-gray-700 text-sm overflow-auto max-h-[80vh]">
          <p>
            1. Informacje ogólne<br>
            Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem url: projectspot.pl.<br>
            Operatorem serwisu oraz Administratorem danych osobowych jest: Szymon Chossa, Rosvelta 6/7, Poznań 60-880.<br>
            Adres kontaktowy poczty elektronicznej operatora: biuro@projectspot.pl.<br>
            Operator jest Administratorem Twoich danych osobowych w odniesieniu do danych podanych dobrowolnie w Serwisie.<br>
            Serwis wykorzystuje dane osobowe w następujących celach:<br>
            - Prowadzenie newslettera<br>
            - Prowadzenie systemu komentarzy<br>
            - Prowadzenie rozmów typu chat online<br>
            - Obsługa zapytań przez formularz<br>
            - Realizacja zamówionych usług<br>
            - Prezentacja oferty lub informacji<br><br>
            2. Wybrane metody ochrony danych stosowane przez Operatora<br>
            - Miejsca logowania i wprowadzania danych osobowych są chronione certyfikatem SSL.<br>
            - Dane osobowe przechowywane są w bazie danych w postaci zaszyfrowanej.<br>
            - Hasła użytkowników są przechowywane w postaci hashowanej.<br>
            - Operator regularnie wykonuje kopie bezpieczeństwa i aktualizuje oprogramowanie.<br><br>
            3. Hosting<br>
            - Serwis jest hostowany na serwerach operatora: home.pl.<br><br>
            4. Twoje prawa i dodatkowe informacje o sposobie wykorzystania danych<br>
            - Możesz zażądać dostępu, sprostowania, usunięcia i przenoszenia swoich danych.<br>
            - Masz prawo do sprzeciwu wobec przetwarzania danych osobowych.<br>
            - Możesz wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych.<br><br>
            5. Informacje w formularzach<br>
            - Serwis zbiera informacje podane dobrowolnie przez użytkownika.<br>
            - Może zapisywać parametry połączenia i informacje o użytkownikach.<br><br>
            6. Logi Administratora<br>
            - Informacje o zachowaniu użytkowników mogą podlegać logowaniu w celach administracyjnych.<br><br>
            7. Istotne techniki marketingowe<br>
            - Operator korzysta z Google Analytics oraz Facebook Pixel do analizy ruchu i remarketingu.<br><br>
            8. Informacja o plikach cookies<br>
            - Serwis korzysta z plików cookies do obsługi sesji i analizy statystycznej.<br>
            - Możesz zarządzać ustawieniami cookies w swojej przeglądarce.<br><br>
          </p>
        </div>
        <button @click="showPrivacyPolicy = false" class="mt-4 bg-[#E9A53D] text-white px-4 py-2 rounded hover:bg-orange-700">
          Zamknij
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { useRouter } from "vue-router";
import { nextTick } from "vue";

export default {
  data() {
    return {
      showPrivacyPolicy: false,
    };
  },
  setup() {
    const router = useRouter();

    const scrollToTextComponent = () => {
      router.push('/').then(() => {
        nextTick(() => {
          const textComponent = document.getElementById("text-component");
          if (textComponent) {
            textComponent.scrollIntoView({ behavior: "smooth" });
          }
        });
      });
    };

    return { scrollToTextComponent };
  },
};
</script>
